module.exports = {
  "id": "pixel sketch",
  "tutorialLink": "https://makeymakey.com/blogs/how-to-instructions/pixel-sketch-sticky-note-art-with-makey-max-backpack",
  "title": "Pixel Sketch",
  "scenes": [{
    "id": "main",
    "metadata": "main.json",
    "sb3": "pixel sketch.sb3"
  }],
  "projectInfo": "",
  "levels": [
    "main"    
  ],
  "exposedVariables": [
    {
      "variableName": "grid size",
      "spriteName": "Stage",
      "value": 5,
      "input": {
        "type": "option",
        "options": [
          {
            "value": "5",
            "label": "5"
          },
          {
            "value": "8",
            "label": "8"
          }
        ]
      }
    },    
    {
      "variableName": "# of colors",
      "spriteName": "Stage",
      "value": 4,
      "input": {
        "type": "option",
        "options": [
          {
            "value": "2",
            "label": "2"
          },
          {
            "value": "4",
            "label": "4"
          },
          {
            "value": "8",
            "label": "8"
          },
          {
            "value": "16",
            "label": "16"
          }
        ]
      }
    }
  ],
  "startingGlitches": [
  ],
  "thumbnail": "/provision/projects/pixel sketch/pixel sketch.png",
  "category": "games",
  "toolbar":{
    "glitches":[],
    "parts":[]
  }
}
;